import { render, staticRenderFns } from "./TikTokAnalyticsPublicTrafficSource.vue?vue&type=template&id=35dda08c&scoped=true"
import script from "./TikTokAnalyticsPublicTrafficSource.vue?vue&type=script&lang=ts"
export * from "./TikTokAnalyticsPublicTrafficSource.vue?vue&type=script&lang=ts"
import style0 from "./TikTokAnalyticsPublicTrafficSource.vue?vue&type=style&index=0&id=35dda08c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dda08c",
  null
  
)

export default component.exports